import { fetchOffers, fetchUserOffers, deleteOffer } from "@/api";
import type { OfferItem, IFetchOffersParams } from "@/shared/types";

export interface IGetOffersParams extends IFetchOffersParams {
  limit?: number;
  offset?: number;
}

export const useOffersStore = defineStore("offers", () => {
  const offers = ref<OfferItem[]>([]);
  const userOffers = ref<OfferItem[]>([]);
  const loading = ref(true);

  const getOffers = async (params: IGetOffersParams, signal?: AbortSignal) => {
    loading.value = true;
    const fetchParams = {
      ...params,
      limit: params.limit || 100,
      offset: params.offset || 0,
      currencyIn: params.send,
      currencyOut: params.recieve,
    };
    try {
      const res = await fetchOffers(fetchParams, signal);
      const newOffers =
        fetchParams.offset === 0 ? res : [...offers.value, ...res];
      offers.value = newOffers;
      loading.value = false;
      return res;
    } catch (e: any) {}
  };

  const getUserOffers = async (params?: IGetOffersParams) => {
    loading.value = true;
    const fetchParams = {
      limit: params?.limit || 100,
      offset: params?.offset || 0,
    };
    const res = await fetchUserOffers(fetchParams);
    const newOffers =
      fetchParams.offset === 0 ? res : [...userOffers.value, ...res];
    userOffers.value = newOffers;
    loading.value = false;
  };

  const deleteMyOffer = async (offerId: number) => {
    await deleteOffer(offerId);
    userOffers.value = userOffers.value.filter((o) => o.offerId !== offerId);
  };
  return {
    offers,
    loading,
    getOffers,
    userOffers,
    getUserOffers,
    deleteMyOffer,
  };
});
